export const environment = {
  production: true,
  basePath: '',
  host: '',
  imageUrl: '',
  // CAAS RELATED
  caasUrl:
    'https://partnerwelt.core.uat.aws.tacp.cloud-talanx.com/hdi-uat/0a069403-291c-40f5-9fd8-cb6c30d1470a',
  caasNavigationUrl:
    'https://partnerwelt.core.uat.aws.tacp.cloud-talanx.com/hdi-partnerwelt',
  caasMedia: 'https://partnerwelt.core.uat.aws.tacp.cloud-talanx.com/media/',
  preview: false,

  // will delete later
  navigationToken: undefined,
  releaseToken: undefined,
  previewToken: undefined,
};
